module.exports = __webpack_public_path__ + "img/search-empty_dark.c5699d2f.png";